/** Detect common image formats; pass mimeType for other browser-supported formats. */
const inferImageMimeType = (base64: string): string | undefined => {
  if (base64.startsWith('iVBORw0KGgo')) return 'image/png';
  if (base64.startsWith('/9j/')) return 'image/jpeg';
  if (base64.startsWith('R0lGOD')) return 'image/gif';
  if (base64.startsWith('UklGR')) return 'image/webp';
  if (base64.startsWith('Qk')) return 'image/bmp';
  if (base64.startsWith('AAABAA')) return 'image/x-icon';
  if (/^(SUkq|TU0AK)/.test(base64)) return 'image/tiff';
  try {
    const header = atob(base64.slice(0, 128));
    if (/^\s*(<svg|<\?xml)/i.test(header)) return 'image/svg+xml';
    if (header.includes('ftypavif') || header.includes('ftypavis')) {
      return 'image/avif';
    }
  } catch {
    // URLs and paths are valid sources too.
  }
  return undefined;
};

/** Preserve URLs/paths; normalize raw Base64 without assuming every image is PNG. */
export const getImageSource = (
  value?: string | null,
  mimeType?: string,
  isBase64 = false,
): string => {
  const source = value?.trim() || '';
  if (!source || /^(data:|blob:|https?:\/\/|\/\/)/i.test(source)) return source;
  const compact = source.replace(/\s/g, '');
  const inferredType = inferImageMimeType(compact);
  if (isBase64 || inferredType) {
    return `data:${mimeType || inferredType || 'image/png'};base64,${compact}`;
  }
  return source;
};
